import { render, staticRenderFns } from "./SetupPayments.vue?vue&type=template&id=6a5c0ecb&scoped=true&"
import script from "./SetupPayments.vue?vue&type=script&lang=js&"
export * from "./SetupPayments.vue?vue&type=script&lang=js&"
import style0 from "./SetupPayments.vue?vue&type=style&index=0&id=6a5c0ecb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c0ecb",
  null
  
)

export default component.exports